import React, { FunctionComponent } from 'react';

export interface ISeoComponentProps {
  title?: string;
  description?: string;
  ogImage?: string;
  ogType?: string;
  noIndex?: string;
  seoCanonicalLink?: string;
  currentUrl?: string;
  lang?: string;
  script?: string;
}

export const SeoComponent: FunctionComponent<ISeoComponentProps> = props => {
  const {
    title,
    description,
    ogImage,
    ogType,
    noIndex,
    seoCanonicalLink,
    currentUrl,
    lang,
    script
  } = props;

  const dreamDataScript = `!function(){window.analytics||(window.analytics=[]),window.analytics.methods=["identify","track","trackLink","trackForm","trackClick","trackSubmit","page","pageview","ab","alias","ready","group","on","once","off"],window.analytics.factory=function(a){return function(){var t=Array.prototype.slice.call(arguments);return t.unshift(a),window.analytics.push(t),window.analytics}};for(var a=0;a<window.analytics.methods.length;a++){var t=window.analytics.methods[a];window.analytics[t]=window.analytics.factory(t)}analytics.load=function(a){if(!document.getElementById("dreamdata-analytics")){window.__DD_TEMP_ANALYTICS__=window.analytics;var t=document.createElement("script");t.async=!0,t.id="dreamdata-analytics",t.type="text/javascript",t.src="https://cdn.dreamdata.cloud/scripts/analytics/v1/dreamdata.min.js",t.addEventListener("load",function(t){if(analytics&&analytics.initialize)for(analytics.initialize({"Dreamdata.io":{apiKey:a}});window.__DD_TEMP_ANALYTICS__.length>0;){var i=window.__DD_TEMP_ANALYTICS__.shift(),n=i.shift();analytics[n]&&analytics[n].apply(analytics,i)}},!1);var i=document.getElementsByTagName("script")[0];i.parentNode.insertBefore(t,i)}},analytics.load("438db5f2-45a3-42c9-904a-b5fe4cf0bd4b"),analytics.page()}();`;

  //initialization of RB2B - Person - Level Website Visitor Identity
  const reb2bScript = `!function(){
         var reb2b = window.reb2b = window.reb2b || [];
  
         if (reb2b.invoked) return;
  
         reb2b.invoked = true;
         reb2b.methods = ["identify", "collect"];
         reb2b.factory = function (method)
         {
           return function () {
             var args = Array.prototype.slice.call(arguments);
         args.unshift(method);
         reb2b.push(args);
         return reb2b;
           };
         };
  
         for (var i = 0; i < reb2b.methods.length; i++)
         {
         var key = reb2b.methods[i];
         reb2b[key] = reb2b.factory(key);
         }
  
         reb2b.load = function (key)
         {
         var script = document.createElement("script");
         script.type = "text/javascript";
         script.async = true;
         script.src = "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" + key + "/reb2b.js.gz";
         var first = document.getElementsByTagName("script")[0];
         first.parentNode.insertBefore(script, first);
       };
         reb2b.SNIPPET_VERSION = "1.0.1";reb2b.load("${process.env.GATSBY_RB2B_API_KEY}");}()`

  const shouldRenderCanonicalLink = Boolean(seoCanonicalLink || currentUrl);

  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {title && <meta property="og:title" content={title} />}
      {ogType && <meta property="og:type" content={ogType} />}
      {ogImage && <meta name="image" property="og:image" content={ogImage} />}
      {description && <meta property="og:description" content={description} />}
      <meta name="twitter:card" content="summary" />
      {noIndex === 'true' && <meta name="robots" content={noIndex} />}
      {shouldRenderCanonicalLink && (
        <link
          rel="canonical"
          href={currentUrl ? currentUrl : seoCanonicalLink}
        />
      )}
      {lang && (
        <link
          rel="alternate"
          hrefLang={lang}
          href={currentUrl ? currentUrl : seoCanonicalLink}
        />
      )}
      {script && <script>{script}</script>}
      {dreamDataScript && <script>{dreamDataScript}</script>}
      <script
        async
        id="dreamdata-form-identify"
        src="https://cdn.dreamdata.cloud/scripts/identify-form/v1/identify-form.min.js"
      ></script>

      {reb2bScript && <script>{reb2bScript}</script>} 
    </>
  );
};
